// extracted by mini-css-extract-plugin
module.exports = {"changeLangButton":"ParentAdvice_changeLangButton__24GeB","wrapper":"ParentAdvice_wrapper__2NcET"};